export { default } from './Poster';
